module.exports = "/_next/static/images/am-dfe2bd05a39bceaf45db2af868a11c47.svg";